import React, { useState } from "react";
import { Box, Stack, Typography, Button, Tabs, Tab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import OverviewReferral from "./OverviewReferral";
import CampaignsReferral from "./CampaignsReferral";
import MembersReferral from "./MembersReferral";
import RewardsReferral from "./RewardsReferral";
import RulesReferral from "./RulesReferral";
import ActivityLogReferral from "./ActivityLogReferral";
import AnalyticsReferral from "./AnalyticsReferral";
import FraudReferral from "./FraudReferral";

const TABS = [
  { label: "Overview", Component: OverviewReferral },
  { label: "Campaigns", Component: CampaignsReferral },
  { label: "Members", Component: MembersReferral },
  { label: "Rewards", Component: RewardsReferral },
  { label: "Rules", Component: RulesReferral },
  { label: "Activity Log", Component: ActivityLogReferral },
  { label: "Analytics", Component: AnalyticsReferral },
  { label: "Fraud", Component: FraudReferral },
];

export default function Referral({ onCreateCampaign, onExport }) {
  const [activeTab, setActiveTab] = useState(0);
  const ActiveComponent = TABS[activeTab].Component;

  return (
    <Box sx={{ m: { xs: 2, md: 3 } }}>
      {/* Header — shared across all tabs */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#000000" }}>
            Referral Program
          </Typography>
          <Typography variant="body2" sx={{ color: "#535353" }}>
            Manage and track the performance of your referral program.
          </Typography>
        </Box>
        <Stack direction="row" spacing={1.5}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={onCreateCampaign}
            sx={{ bgcolor: "#000000", "&:hover": { bgcolor: "#1F2937" }, textTransform: "none", borderRadius: 2 }}
          >
            Create Campaign
          </Button>
          <Button
            variant="outlined"
            startIcon={<FileDownloadOutlinedIcon />}
            onClick={onExport}
            sx={{ borderColor: "#E5E7EB", color: "#374151", textTransform: "none", borderRadius: 2 }}
          >
            Export
          </Button>
        </Stack>
      </Stack>

      {/* Tabs — shared across all tabs */}
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          mb: 3,
          borderBottom: "1px solid #E5E7EB",
          minHeight: 40,
          "& .MuiTab-root": { textTransform: "none", color: "#535353" },
          "& .Mui-selected": { bgcolor: "transparent !important", color:"#000000 !important" },
          "& .MuiTabs-indicator": { bgcolor: "#3FBEAC" },
        }}
      >
        {TABS.map((t) => (
          <Tab key={t.label} label={t.label} />
        ))}
      </Tabs>

      {/* Active tab content */}
      <ActiveComponent />
    </Box>
  );
}